<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="JiuDianList" data-title="酒店库">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column :min-width="260" label="名称">
          <template #default="{ row }">
            <div class="flex items-center gap-x-2">
              <strong
                @click="
                  $openMenu({
                    path: 'JiuDianDetail',
                    title: '酒店详情-' + row.name,
                    refresh: true,
                    data: {
                      id: row.id,
                    },
                  })
                "
                class="text-green-700 cursor-pointer hover:underline"
              >
                {{ row.name }}
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column :width="160">
          <template #header>
            <div class="c-table-col-header" label1="联系人" label2="电话" />
          </template>
          <template #default="{ row }">
            <text>{{ row.contact_name }}</text>
            <c_sex :value="row.contact_title == '先生' ? '男' : '女'" />
            <text class="ml-1 text-gray-400 text-xs">
              {{ row.contact_phone }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="房型"
          prop="hotelRoomType.room_type_count"
          :width="120"
          align="center"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="房间数"
          prop="hotelRoomType.count"
          align="center"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="地址"
          :min-width="160"
          prop="address"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="备注"
          prop="remark"
          :min-width="160"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="负责人" :width="140">
          <template #default="{ row }">
            <text>{{ row.belonger_name }}</text>
            <text class="text-gray-400 text-xs ml-1">{{
              row.belonger_department_name
            }}</text>
          </template>
        </el-table-column>
        <el-table-column label="状态" fixed="right" align="center" :width="120">
          <template #default="{ row }">
            <el-switch
              v-model="row.status"
              active-text="启用"
              inactive-text="禁用"
              :active-value="1"
              :inactive-value="0"
              :disabled="!row.id"
              inline-prompt
              @change="onUpdateStatus($event, row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="200">
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              >编辑
            </el-button>
            <el-button
              type="success"
              :icon="Connection"
              link
              @click="
                $openMenu({
                  path: 'JiuDianDetail',
                  title: '酒店详情-' + row.name,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              管理
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑酒店' : '新建酒店'"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
    width="70%"
  >
    <c_info
      :id="state.selectId"
      @close="
        (refresh) => {
          state.showInfo = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { ElMessageBox } from "element-plus";
import { hotel_page, hotel_updateStatus, hotel_delete } from "@/http/hotel";
import { onDeleteConfirm } from "@/utils/funcs";
import { post_response } from "@/utils/funcs";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_info,
  },
  setup() {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      hotel_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(hotel_delete, row.id, onLoad, {
        filed: "酒店",
        name: row.name,
      });
    };

    const onUpdateStatus = (value, row) => {
      ElMessageBox.confirm(
        `您确定${
          row.status == 1
            ? '<strong style="color: var(--el-color-success);">启用</strong>'
            : '<strong style="color: var(--el-color-danger);">禁用</strong>'
        }酒店<strong style="font-weight:bold;color:#000">${
          row.name
        }</strong>吗？`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      )
        .then(() => {
          hotel_updateStatus({
            id: row.id,
            status: row.status,
          }).then((res) => {
            post_response(res, onLoad);
          });
        })
        .catch(() => {
          row.status = value ? 0 : 1;
        });
    };

    return { state, onLoad, onDelete, onUpdateStatus };
  },
};
</script>

<style lang="scss" scoped></style>
